// extracted by mini-css-extract-plugin
export default {"PageScrollPane":"b121gI0R6j54cooOMQRd"};